import {
  GROUPTEMPLATELIST,
  SETTINGPROJECTS,
  SETTINGSELECTEDPROJECT,
  SELECTEDPROJECTUNITS,
  SETTINGGLASSES,
  REGET,
} from "Stores/actionTypes";
import { updateObject } from "../utility";
const initialState = {
  groupTemplate_List: [],
  groupTemplate_Pagination: { Limit: 5, Page: 1, Total: 0 },
  settingProjects_List: [],
  settingProjects_Pagination: { Limit: 5, Page: 1, Total: 0 },
  selectedProject: null,
  selectedProjectUnits_List: [],
  selectedProjectUnits_Pagination: { Limit: 5, Page: 1, Total: 0 },
  settingGlasses_List: [],
  settingGlasses_Pagination: { Limit: 5, Page: 1, Total: 0 },
  reget: false,
  taskId: null,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case GROUPTEMPLATELIST:
      return updateObject(state, {
        groupTemplate_List: action.list,
        groupTemplate_Pagination: action.pagination,
      });

    case SETTINGPROJECTS:
      return updateObject(state, {
        settingProjects_List: action.list,
        settingProjects_Pagination: action.pagination,
      });

    case SETTINGSELECTEDPROJECT:
      return updateObject(state, {
        selectedProject: action.project,
      });

    case SELECTEDPROJECTUNITS:
      return updateObject(state, {
        selectedProjectUnits_List: action.list,
        selectedProjectUnits_Pagination:
          action.pagination || state.selectedProjectUnits_Pagination,
      });

    case SETTINGGLASSES:
      return updateObject(state, {
        settingGlasses_List: action.list,
        settingGlasses_Pagination: action.pagination,
      });

    case REGET:
      return updateObject(state, {
        taskId: action.status ? action.Id : null,
        reget: action.status,
      });

    default:
      return state;
  }
};

export default reducer;
